/**
 * Nested sub-nav for the "Access & Profiles" config tab: a second pill row
 * (Access Roles / Profile Visibility) + an <Outlet/> for the chosen page.
 * Sits under the main config tab row (ConfigLayout) — no own container.
 */
import { Outlet } from 'react-router-dom';
import { TabRow, type SectionTab } from '../../components/SectionTabs';

const TABS: SectionTab[] = [
  { to: '/admin/config/access', label: 'Access Roles', end: true },
  { to: '/admin/config/profile', label: 'Profile Visibility', end: true },
];

export function ConfigAccessProfilesLayout() {
  return (
    <div className="space-y-5">
      <TabRow tabs={TABS} wrap />
      <Outlet />
    </div>
  );
}
